// import { NullString } from "../../utilities/NullUtil";
import { NullString } from "../../utilities/NullUtil";
import * as FileSaver from "file-saver";
//import { formatDateFile } from "../../utils/DateUtil";
import { formatDateFile } from "../../utilities/DateUtil";

export const renderExportFile = async (data, exportType, menuCode = "", setDialogFile = undefined) => {
    if (data !== undefined && NullString(exportType) !== "") {
        let fileName = (menuCode === "" ? "" : menuCode + "_") + formatDateFile(new Date(), true);
        const blobData = new Blob([data], { type: "application/" + exportType });
        if (exportType === "pdf" && setDialogFile !== undefined) {
            let base64data = await blobToBase64(blobData);
            if (base64data && base64data !== "") {
                setDialogFile({ open: true, urlFile: base64data });
            }
        } else {
            FileSaver.saveAs(blobData, fileName + "." + exportType);
        }
    }
};

export const renderExportFileWindow = async (data, exportType, menuCode = "") => {
    if (data !== undefined && NullString(exportType) !== "") {
        let fileName = (menuCode === "" ? "" : menuCode + "_")+ formatDateFile(new Date(), true);
        console.log("fileName : ",fileName)
        const blobData = new Blob([data], { type: "application/" + exportType });

        if (exportType === "pdf") {
            const fileURL = URL.createObjectURL(blobData);
            const pdfWindow = window.open();
            pdfWindow.location.href = fileURL;
        } else {
            FileSaver.saveAs(blobData, fileName + "." + exportType);
        }
    }
};
export const renderExportFileWindowCsv = async (data, exportType, fileName) => {
    if (data !== undefined && NullString(exportType) !== "") {
        const blobData = new Blob([data], { type: "text/csv" });

        // if(exportType === "csv"){
        //  const fileURL = URL.createObjectURL(blobData);
        //  const pdfWindow = window.open();
        //  console.log(pdfWindow);
        //  console.log(fileURL);
        //  pdfWindow.location.href = fileURL;
        // }else{
        FileSaver.saveAs(blobData, fileName + "." + exportType);
        // }
    }
};

const blobToBase64 = async (blob) => {
    return new Promise(async (resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        try {
            reader.readAsDataURL(blob);
        } catch (e) {
            reject(undefined);
        }
    });
};

export const downloadFile = async (url) => {

    const file = getFileNameFromURL(url);

    const arrayFile = file.split(".");
    let filename = arrayFile[0];
    let typefile = arrayFile[1];

    fetch({ url }).then((response) => {
        response.blob().then((blob) => {
            var FileSaver = require("file-saver");
            if (typefile === "pdf" || typefile === "PDF") {
                // const fileURL = URL.createObjectURL(blobData);
                // const pdfWindow = window.open();
                // pdfWindow.location.href = fileURL;
                window.open(url, "_blank");
            } else if (typefile === "mp4" || typefile === "mp4") {
               
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename); 
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                // const blobData = new Blob([blob], { type: "video/mp4" });
                // FileSaver.saveAs(blobData,filename);
            } else {
                const blobData = new Blob([blob], { type: "application/" + typefile });
                FileSaver.saveAs(blobData, filename);
            }
        });
    });
}; 

function getFileNameFromURL(url) {

    const segments = url.split('/');

    const filename = segments[segments.length - 1];
    
    return filename;
}
  